<template>
    <el-dialog
            title="打卡详情"
            width="90%"
            :close-on-click-modal="false"
            :visible.sync="visible"
            style="text-align: left">
        <el-container style="height: 100%">
            <el-aside width="20%">
                <div class="map_dialog" >
                    <el-row>
                        <el-date-picker
                                size="mini"
                                @change="changeTime"
                                v-model="dataForm.date"
                                placeholder="打卡日期"
                                type="date"
                                value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-row>
                    <el-row>
                        <el-table
                                size="mini"
                                :data="tableData"
                                style="width: 100%">
                            <el-table-column type="expand">
                                <template slot-scope="props">
                                    <el-form size="mini" label-position="left" inline >
                                        <el-form-item label="姓名:">
                                            <span>{{ props.row.xm }}</span>
                                        </el-form-item>
                                        <el-form-item label="部门:">
                                            <span>{{ props.row.bmmc }}</span>
                                        </el-form-item>
                                        <el-form-item label="工号:">
                                            <span>{{ props.row.username }}</span>
                                        </el-form-item>
                                        <el-form-item label="打卡时间:">
                                            <span>{{ props.row.dksj }}</span>
                                        </el-form-item>
                                        <el-form-item label="打卡类型:">
                                            <span>{{ props.row.dklx==='0'?'上班':'下班' }}</span>
                                        </el-form-item>
                                        <el-form-item label="状态:">
                                            <span>{{ props.row.status === '0'?'正常':props.row.status === '1'?'补卡':props.row.status === '2'?'迟到':'早退' }}</span>
                                        </el-form-item>
                                        <el-form-item label="班次类型:">
                                            <span>{{ props.row.bclx === '1'?'早班':props.row.bclx === '2'?'中班':'晚班' }}</span>
                                        </el-form-item>
                                    </el-form>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="姓名"
                                    prop="xm">
                            </el-table-column>
                            <el-table-column
                                    label="打卡时间"
                                    width="150"
                                    prop="dksj">
                            </el-table-column>
                            <el-table-column
                                    label="类型"
                            >
                                <template slot-scope="scope">
                                    {{scope.row.dklx === '0'?'上班':'下班'}}
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination small layout="total,prev, pager, next" :total="total"
                                       :page-size="10"
                                       @current-change="pageUser" style="margin-top: 1rem;"></el-pagination>
                    </el-row>


                </div>
            </el-aside>
            <el-main>
                <div class="amap-page-container">
                    <el-amap ref="map" vid="amapDemo" :amap-manager="amapManager" :center="center" :zoom="zoom.zoom"  class="amap-demo"
                             style="position: relative;" :events="events">
                        <el-date-picker
                                size="mini"
                                :clearable="false"
                                @change="getTraceDate"
                                style="position: absolute;z-index: 500;top: 20px;left: 20px;"
                                v-model="dataForm.pbDate"
                                placeholder="打卡日期"
                                type="date"
                                value-format="yyyy-MM-dd">
                        </el-date-picker>
                        <el-amap-marker :icon="marker.icon" :vid="marker.id" v-for="marker in markers2" :position="marker.position[0]" :events="marker.events"></el-amap-marker>
                        <el-amap-polyline :stroke-color="polyline.color"  :editable="polyline.editable"  :path="polyline.path"  v-for="polyline in polylines" ></el-amap-polyline>

                        <el-amap-info-window  :position="window.position" :visible="window.visible" :offset="[0,-20]">
                            <div>
                                <div class="MapPopBox">
                                    <div class="DeviceInfo">
                                        <div class="item">
                                            <ul>
                                                <li>
                                                    <span class="item-title">姓名：</span>
                                                    <span class="item-info"  v-text="window.info.name"></span>
                                                </li>
                                                <li>
                                                    <span class="item-title">工号：</span>
                                                    <span class="item-info"  v-text="window.info.username"></span>
                                                </li>
                                                <li>
                                                    <span class="item-title">部门名称：</span>
                                                    <span class="item-info"  v-text="window.info.bmmc"></span>
                                                </li>
                                                <li>
                                                    <span class="item-title">打卡时间：</span>
                                                    <span class="item-info"  v-text="window.info.dksj"></span>
                                                </li>
                                                <li>
                                                    <span class="item-title">班次类型：</span>
                                                    <span class="item-info"  v-text="window.info.bclx === '1'?'早班':window.info.bclx === '2'?'中班':'晚班'"></span>
                                                </li>
                                                <li>
                                                    <span class="item-title">打卡类型：</span>
                                                    <span class="item-info"  v-text="window.info.dklx==='0'?'上班':'下班'"></span>
                                                </li>
                                                <li>
                                                    <span class="item-title">状态：</span>
                                                    <span class="item-info"  v-text="window.info.status === '0'?'正常':window.info.status === '1'?'补卡':window.info.status === '2'?'迟到':'早退'"></span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-amap-info-window>
                    </el-amap>
                </div>
            </el-main>
        </el-container>

        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
    </span>
    </el-dialog>
</template>

<script>
    import VueAMap from 'vue-amap'
    import markr from '../../../assets/bjba/map/mark_r.png'
    import Template from "../../../template";
    import {Loading} from "element-ui";
    export default {
        components: {Template},
        data () {
            return {
                visible: false,
                dataForm: {
                    gdid:'',
                    date:'',
                    pbDate:''
                },
                amapManager: new VueAMap.AMapManager(),
                markersGd:[],
                startTime:'',
                total:0,
                currentPage:1,
                tableData:[],
                colorList:['#22782e','#f20c0c','#0c10ae','#1163df','#0805f4'],
                polylines: [],
                markerPatrol:[],
                markers2:[],
                circle:'',
                window: {
                    position:[121.506377, 31.245105],
                    visible: false,
                    info: {

                    }
                },
                zoom: {
                    zoom: 12
                },
                events: {
                    zoomchange: (e) => {
                        this.zoom.zoom=this.$refs.map.$$getInstance().getZoom()
                    }
                },
                center: [121.506377, 31.245105],
                circles:[],
                icon:markr
            }
        },
        methods: {
            init (obj) {
                if(!obj) return;
                this.polylines = []
                this.markers2 = []
                console.log('123123123132'+this.$moment().format('YYYY-MM-DD'))
                this.dataForm.pbDate = this.$moment().format('YYYY-MM-DD')
                this.dataForm.name
                this.visible = true
                this.$nextTick(() => {
                    this.dataForm.gdid = obj
                    this.searchData()
                    this.getTraceDate()
                })

            },
            changeTime() {
                this.currentPage = 1;
                this.searchData()
            },
            searchData() {
                this.$http({
                    url: '/bjba/outsideGdxx/dkPage',
                    method: 'get',
                    params:{gdid:this.dataForm.gdid,date:this.dataForm.date,page:this.currentPage,pagesize:10}
                }).then(({data}) => {
                    this.tableData = data.data.content
                    this.total = data.data.totalElements
                })
            },
            getTraceDate() {
                this.polylines = []
                this.markers2 = []
                let loadingInstance1 = Loading.service({ fullscreen: true });
                let url = ''
                var _that = this;
                this.$request({
                    method: 'get',
                    url: '/bjba/outsideGdxx/dkList',
                    params: {pbDate:this.dataForm.pbDate,gdid:this.dataForm.gdid}
                }).then((response)=>{
                    loadingInstance1.close()
                    if(response.data) {
                        if(!this.hasdata(response.data.data) ){
                            this.$message.warning(`${this.dataForm.pbDate}暂无打卡信息`)
                            return
                        }
                        for(const key in response.data.data){
                            let datalist = response.data.data[key]
                            if(datalist && datalist.length >0) {
                                let path =[]
                                for(var i =0;i < datalist.length; i++) {
                                    const position =[datalist[i].longitude,datalist[i].latitude];
                                    if(i===0) {this.center=position;this.zoom.zoom = 24}

                                    path.push(position)
                                    const element = datalist[i]
                                    let newmarker ={}
                                    newmarker = {
                                        position: [position],
                                        vid: element.id,
                                        events: {
                                            mouseover:(e) => {
                                                _that.window.visible = false
                                                _that.window.info.name = element.xm
                                                _that.window.info.username = element.username
                                                _that.window.info.bmmc = element.bmmc
                                                _that.window.info.dksj = element.dksj
                                                _that.window.info.dklx = element.dklx
                                                _that.window.info.bclx = element.bclx
                                                _that.window.info.status = element.status
                                                this.$nextTick(() => {
                                                    _that.window.visible = true
                                                    _that.window.position = position
                                                })
                                            },
                                            mouseout:(e) => {
                                                _that.window.visible = false
                                                _that.window.info.name = ''
                                                _that.window.info.name = ''
                                                _that.window.info.username = ''
                                                _that.window.info.bmmc = ''
                                                _that.window.info.dksj = ''
                                                _that.window.info.dklx = ''
                                                _that.window.info.bclx = ''
                                                _that.window.info.status = ''
                                                this.$nextTick(() => {
                                                    _that.window.visible = false
                                                })
                                            }
                                        }
                                    };
                                    if (element.dklx === '1') {
                                        newmarker.icon = markr
                                    }
                                    this.markers2.push(newmarker);
                                }
                                let newpolyline = {
                                    path:path,
                                    editable: false,
                                    color: _that.colorList[Math.round(Math.random()*4)]
                                }
                                this.polylines.push(newpolyline)
                            }

                        }
                    }
                }).catch((err)=>{
                    loadingInstance1.close()
                    console.log(err)
                });
            },
            hasdata(obj) {
                for (var i in obj) { // 如果不为空，则会执行到这一步，返回true
                    return true
                }
                return false // 如果为空,返回false
            },
            pageUser(page) {
                this.currentPage = page
                this.searchData()
            }
        }
    }
</script>
<style lang="scss" scoped>
    .min-input-class {

        min-height:25px;
        border-bottom:1px dotted  #b0b1b3;
    }
    .amap-page-container {
        height: 500px;
        width: 100%;
        margin: 0.5rem 0.5rem 0.5rem 0.5rem;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
    }
</style>
